export const getCountryName = (countryCode: string, language: string): string => {
    const displayNames = new Intl.DisplayNames([language], { type: 'region' });

    return displayNames.of(countryCode) ?? countryCode;
};
